module.exports = __webpack_public_path__ + "static/media/Woman-in-lingerie-451109-min.dfc37ee9.jpg";